import React, { useState } from 'react';
import { api } from './api/api';

const CT_STEPS = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];

const TrackGainsModal = ({ trackId, gains, onClose, onSaved }) => {
  const [lapGain100Ct, setLapGain100Ct] = useState(gains?.lapGain100Ct ?? '');
  const [raceGain100Ct, setRaceGain100Ct] = useState(gains?.raceGain100Ct ?? '');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [saved, setSaved] = useState(false);

  const previewLap = lapGain100Ct === '' ? null : parseFloat(lapGain100Ct);
  const previewRace = raceGain100Ct === '' ? null : parseFloat(raceGain100Ct);

  const handleSave = async () => {
    setSaving(true);
    setError(null);
    setSaved(false);
    try {
      const body = {};
      if (lapGain100Ct !== '') body.lapGain100Ct = parseFloat(lapGain100Ct);
      if (raceGain100Ct !== '') body.raceGain100Ct = parseFloat(raceGain100Ct);
      await api.put(`/track/gains/${trackId}`, body);
      const res = await api.get(`/track/gains/${trackId}`);
      setSaved(true);
      onSaved?.(res.data);
    } catch (err) {
      setError(err.response?.status === 403 ? 'Access denied (ADMIN only).' : 'Failed to save.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
    }} onClick={onClose}>
      <div style={{
        background: '#fff', borderRadius: 'var(--radius-lg)',
        padding: 24, width: 460, maxWidth: '95vw',
        boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
      }} onClick={e => e.stopPropagation()}>
        <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 4 }}>
          Lap / Race Gain — {gains?.trackName ?? `Track #${trackId}`}
        </div>
        <div style={{ fontSize: 12, color: 'var(--c-text-muted)', marginBottom: 16 }}>
          Values are per 100 CT; the table below is a linear projection for 10–100 CT.
        </div>

        <div style={{ display: 'flex', gap: 12, marginBottom: 16 }}>
          <div style={{ flex: 1 }}>
            <label style={{ display: 'block', fontSize: 12, color: 'var(--c-text-muted)', marginBottom: 4 }}>
              Lap Gain @100CT
            </label>
            <input type="number" step="0.001" value={lapGain100Ct}
              onChange={e => setLapGain100Ct(e.target.value)}
              style={{ width: '100%', padding: '7px 10px', border: '1px solid var(--c-border)', borderRadius: 'var(--radius-sm)', fontSize: 13 }} />
          </div>
          <div style={{ flex: 1 }}>
            <label style={{ display: 'block', fontSize: 12, color: 'var(--c-text-muted)', marginBottom: 4 }}>
              Race Gain @100CT
            </label>
            <input type="number" step="0.001" value={raceGain100Ct}
              onChange={e => setRaceGain100Ct(e.target.value)}
              style={{ width: '100%', padding: '7px 10px', border: '1px solid var(--c-border)', borderRadius: 'var(--radius-sm)', fontSize: 13 }} />
          </div>
        </div>

        <div className="fb-table-wrap" style={{ marginBottom: 12 }}>
          <table className="fb-table fb-table-sm">
            <thead><tr><th>CT</th><th>Lap Gain</th><th>Race Gain</th></tr></thead>
            <tbody>
              {CT_STEPS.map(ct => (
                <tr key={ct}>
                  <td>{ct}</td>
                  <td>{previewLap != null ? (previewLap * ct / 100).toFixed(3) : '—'}</td>
                  <td>{previewRace != null ? (previewRace * ct / 100).toFixed(3) : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {error && <div style={{ color: 'var(--c-error)', fontSize: 13, marginBottom: 10 }}>{error}</div>}
        {saved && !error && <div style={{ color: '#16a34a', fontSize: 13, marginBottom: 10 }}>Saved.</div>}

        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button onClick={onClose} style={{
            padding: '7px 16px', borderRadius: 'var(--radius-sm)',
            background: '#f9fafb', border: '1px solid var(--c-border)',
            color: 'var(--c-text-muted)', cursor: 'pointer', fontSize: 13,
          }}>Close</button>
          <button onClick={handleSave} disabled={saving} style={{
            padding: '7px 18px', borderRadius: 'var(--radius-sm)',
            background: 'var(--c-accent)', border: 'none',
            color: '#fff', cursor: 'pointer', fontSize: 13, fontWeight: 600,
          }}>{saving ? 'Saving…' : 'Save'}</button>
        </div>
      </div>
    </div>
  );
};

export default TrackGainsModal;
